// MLDC Agro Website Mock Data
// This file contains all the content extracted from the original website

export const companyInfo = {
  name: "MLDC Agro",
  tagline: "Building a financially stronger future for farmers",
  subTagline: "MLDC Agro is a farmer-centric organization dedicated to evolving with the changing needs of Indian agriculture and becoming a one-stop solution for farmers.",
  description: "We indirectly serve a family every second by handling agricultural produce to meet the diverse needs of businesses pan India",
  email: "support@mldcagro.com",
  phone: "+91 6396880323",
  whatsapp: "916396880323",
  address: {
    line1: "Office No. 44, 11th Floor",
    line2: "ithum's Galleria",
    line3: "Sector Alpha 2, Greater Noida",
    line4: "Uttar Pradesh, India - 201310",
    state: "Uttar Pradesh",
    country: "India",
    pincode: "201310"
  },
  mapLink: "https://maps.app.goo.gl/NF79f6pg6Cn32MC79",
  hours: {
    open: "09:00 AM",
    close: "07:00 PM",
    days: "Monday - Saturday"
  },
  socialLinks: {
    facebook: "https://www.facebook.com/profile.php?id=61582488435012",
    instagram: "https://www.instagram.com/mldcagro/",
    linkedin: "https://www.linkedin.com/company/109307253/",
    youtube: "https://www.youtube.com/channel/UCOjQBycHK2P7_nAPyMrTKMA"
  },
  founded: "1960s",
  location: "Anupshahr, Uttar Pradesh"
};

export const aboutContent = {
  history: {
    title: "Our History",
    description: "Founded in Anupshahr (Uttar Pradesh) in the 1960s, MLDC Agro started as a small family-owned business dedicated to delivering high-quality agricultural produce to manufacturers. Today, we have evolved into one of the largest players in Uttar Pradesh, serving customers across India."
  },
  commitment: {
    title: "Our Commitment",
    description: "At MLDC Agro, we are dedicated to fostering lasting relationships with our customers and all stakeholders. We believe that transparency and honesty are the cornerstones of success, and we strive to deliver exceptional service and high-quality agricultural produce at a fair price."
  },
  team: {
    title: "Our Team",
    description: "At MLDC Agro, our team of experienced employees is committed to providing exceptional service to our customers. We work closely with our clients to understand their needs and offer customized solutions that effectively meet their specific requirements for agricultural produce."
  },
  vision: {
    title: "Our Vision",
    description: "To become a one-stop solution platform for farmers across India, making them financially stronger while solving real on-ground agricultural problems."
  },
  mission: {
    title: "Our Mission",
    description: "To evolve continuously with farmers' changing needs, provide quality agricultural solutions, and create a sustainable ecosystem where farmers and businesses thrive together."
  }
};

export const keyManagement = [
  {
    id: 1,
    name: "Ashish Bansal",
    title: "Managing Director",
    description: "Ashish Bansal, a Chartered Accountant and Chartered Financial Analyst who has also completed the Executive Programme in Strategic Management at IIM Ahmedabad has been leading company since 2021. With his strong financial acumen and strategic insight, he is driving the company's growth, focusing on integrating vertically and horizontally in Agri-produce value chain.",
    linkedin: "https://www.linkedin.com/in/inv-ent-ashishbansal/",
    image: "/images/8hoxwns8_028-5weT9p1kfVg.jpeg"
  },
  {
    id: 2,
    name: "Ayush Bansal",
    title: "Director",
    description: "Ayush Bansal, a Chartered Accountant with three years of experience at Deloitte India, joined MLDC Agro in 2025. He brings expertise in finance, auditing, and business strategy to enhance the company's operational and financial excellence, particularly in the agriculture sector.",
    linkedin: "https://www.linkedin.com/in/ayush-bansal-57b044219/",
    image: "/images/ay1sricc_Ayush.png"
  }
];

export const services = [
  {
    id: 1,
    title: "Agricultural Produce Supply",
    description: "We supply high-quality agricultural produce including potatoes, wheat, grains, and other crops to businesses across India.",
    icon: "Wheat"
  },
  {
    id: 2,
    title: "Farmer Partnership Programs",
    description: "Join our network of farmers and get access to better markets, fair prices, and agricultural expertise.",
    icon: "Handshake"
  },
  {
    id: 3,
    title: "Warehousing Facility",
    description: "State-of-art warehousing facility to safely store agri-commodities with best care and management. We also help businesses lease warehousing facilities.",
    icon: "Warehouse"
  },
  {
    id: 4,
    title: "Commodity Finance",
    description: "Flexible financing solutions for farmers and traders against stored commodities, enabling better cash flow management.",
    icon: "Banknote"
  },
  {
    id: 5,
    title: "Cold Storage Facility",
    description: "State-of-the-art cold storage facilities to preserve freshness and quality of agricultural produce for extended periods.",
    icon: "Snowflake"
  },
  {
    id: 6,
    title: "Market Intelligence",
    description: "Real-time market insights and pricing information to help farmers make informed decisions.",
    icon: "TrendingUp"
  },
  {
    id: 7,
    title: "Agricultural Advisory",
    description: "Expert guidance on crop selection, farming techniques, and best practices for maximum yield.",
    icon: "Lightbulb"
  },
  {
    id: 8,
    title: "Logistics & Transportation",
    description: "Efficient logistics network to transport agricultural produce across India with timely delivery.",
    icon: "Truck"
  }
];

export const stats = [
  { value: "60+", label: "Years of Legacy" },
  { value: "10,000+", label: "Farmer Partners" },
  { value: "200+", label: "Business Clients" },
  { value: "Pan India", label: "Delivery Network" }
];

export const whyChooseUs = [
  {
    title: "Farmer-First Approach",
    description: "Every decision we make puts farmers at the center. We grow when farmers grow."
  },
  {
    title: "Transparent Pricing",
    description: "Fair and transparent pricing that benefits both farmers and businesses."
  },
  {
    title: "Quality Guarantee",
    description: "Rigorous quality standards ensure premium agricultural produce every time."
  },
  {
    title: "Pan-India Network",
    description: "Extensive logistics network delivering across India with reliability."
  }
];

export const blogs = [
  {
    id: 1,
    title: "Potato & Contango Markets - Opportunities for Farmers",
    date: "24 October 2025",
    excerpt: "Understanding market dynamics to maximize returns on potato cultivation.",
    slug: "potato-and-contango-markets-opportunities-for-farmers",
    image: "/images/photo-1508313880080-c4bef0730395.jpg",
    content: `
      <div class="blog-content">
        <h2 class="text-2xl font-bold text-[#004534] mb-4 mt-8">Understanding Contango in Potato Markets</h2>
        <p class="text-[#555] leading-relaxed mb-6">The potato market in India presents unique opportunities for farmers who understand the concept of <strong>contango</strong> - a market situation where future prices are higher than spot prices. This creates favorable conditions for storage and delayed selling strategies.</p>
        
        <h3 class="text-xl font-semibold text-[#004534] mb-3 mt-6">What is Contango?</h3>
        <p class="text-[#555] leading-relaxed mb-6">Contango occurs when the futures price of a commodity is higher than the expected future spot price. For potato farmers, this means that <strong>storing potatoes and selling them later</strong> can be more profitable than immediate sale at harvest time.</p>
        
        <h3 class="text-xl font-semibold text-[#004534] mb-3 mt-6">Key Factors Affecting Potato Prices</h3>
        <ul class="list-disc pl-6 mb-6 space-y-2 text-[#555]">
          <li><strong>Seasonal Supply:</strong> Potato prices typically fall during harvest season (February-March) due to abundant supply</li>
          <li><strong>Storage Costs:</strong> Cold storage facilities charge approximately ₹100-150 per quintal for a 6-8 month period</li>
          <li><strong>Market Demand:</strong> Festival seasons and summer months often see increased demand</li>
          <li><strong>Government Policies:</strong> MSP announcements and import/export regulations impact prices</li>
        </ul>
        
        <h3 class="text-xl font-semibold text-[#004534] mb-3 mt-6">Strategies for Maximizing Returns</h3>
        <p class="text-[#555] leading-relaxed mb-4">Farmers can maximize their returns by:</p>
        <ol class="list-decimal pl-6 mb-6 space-y-2 text-[#555]">
          <li>Planning storage based on market forecasts</li>
          <li>Utilizing cold storage facilities during peak harvest</li>
          <li>Monitoring futures markets for price signals</li>
          <li>Diversifying selling across multiple time periods</li>
        </ol>
        
        <div class="bg-[#FAFFEE] border-l-4 border-[#D3FF62] p-6 my-8 rounded-r-lg">
          <h4 class="font-semibold text-[#004534] mb-2">MLDC Agro's Role</h4>
          <p class="text-[#555]">At MLDC Agro, we provide farmers with market intelligence and storage solutions that help them take advantage of contango opportunities. Our network of cold storage facilities and market expertise enables farmers to make informed decisions about when to sell their produce.</p>
        </div>
        
        <p class="text-[#0C6951] font-medium italic mt-8">Contact us to learn more about how we can help you maximize your potato farming returns.</p>
      </div>
    `
  },
  {
    id: 2,
    title: "Organic Farming: The Next 50 Years of Food, Soil, and Opportunity",
    date: "10 January 2026",
    excerpt: "Exploring the future of sustainable agriculture and its benefits.",
    slug: "organic-farming-the-next-50-years",
    image: "/images/photo-1722962674424-3e8fb8d4daf8.jpg",
    content: `
      <div class="blog-content">
        <h2 class="text-2xl font-bold text-[#004534] mb-4 mt-8">The Future of Organic Farming in India</h2>
        <p class="text-[#555] leading-relaxed mb-6">As we look ahead to the next five decades, organic farming stands at the forefront of agricultural transformation. With increasing consumer awareness and government support, organic agriculture presents <strong>tremendous opportunities</strong> for Indian farmers.</p>
        
        <h3 class="text-xl font-semibold text-[#004534] mb-3 mt-6">Why Organic Farming Matters</h3>
        <p class="text-[#555] leading-relaxed mb-6">Organic farming is not just about avoiding chemicals - it's about building a <strong>sustainable food system</strong> that benefits farmers, consumers, and the environment. The global organic food market is projected to reach <strong>$320 billion by 2030</strong>.</p>
        
        <h3 class="text-xl font-semibold text-[#004534] mb-3 mt-6">Benefits of Organic Farming</h3>
        <ul class="list-disc pl-6 mb-6 space-y-3 text-[#555]">
          <li><strong>Soil Health:</strong> Organic practices improve soil structure, water retention, and biodiversity</li>
          <li><strong>Premium Prices:</strong> Organic produce commands 20-40% higher prices in the market</li>
          <li><strong>Lower Input Costs:</strong> Reduced dependency on expensive chemical inputs</li>
          <li><strong>Export Opportunities:</strong> Growing demand in international markets</li>
          <li><strong>Health Benefits:</strong> Healthier food for consumers, safer working conditions for farmers</li>
        </ul>
        
        <h3 class="text-xl font-semibold text-[#004534] mb-3 mt-6">Challenges and Solutions</h3>
        <p class="text-[#555] leading-relaxed mb-4">While organic farming offers numerous benefits, farmers face challenges such as transition period yield drops, certification costs, and market access. <strong>MLDC Agro supports farmers through:</strong></p>
        <ol class="list-decimal pl-6 mb-6 space-y-2 text-[#555]">
          <li>Technical guidance during the transition period</li>
          <li>Market linkages for organic produce</li>
          <li>Access to organic inputs and resources</li>
          <li>Support with certification processes</li>
        </ol>
        
        <div class="bg-[#FAFFEE] border-l-4 border-[#D3FF62] p-6 my-8 rounded-r-lg">
          <h4 class="font-semibold text-[#004534] mb-2">Government Initiatives</h4>
          <p class="text-[#555]">The Indian government's <strong>Paramparagat Krishi Vikas Yojana (PKVY)</strong> and other schemes provide financial support for organic farming adoption. Farmers can receive subsidies for organic inputs, certification, and marketing.</p>
        </div>
        
        <p class="text-[#0C6951] font-medium italic mt-8">Join the organic revolution and build a sustainable future for Indian agriculture.</p>
      </div>
    `
  },
  {
    id: 3,
    title: "Evolving Indian Farmers & Impact on Businesses",
    date: "2 January 2026",
    excerpt: "How modern Indian farmers are transforming the agricultural landscape.",
    slug: "evolving-indian-farmers-impact-on-businesses",
    image: "/images/photo-1589292144899-2f43a71a1b2b.jpg",
    content: `
      <div class="blog-content">
        <h2 class="text-2xl font-bold text-[#004534] mb-4 mt-8">The New Face of Indian Agriculture</h2>
        <p class="text-[#555] leading-relaxed mb-6">The Indian farmer of 2026 is vastly different from a decade ago. With smartphone penetration, digital payments, and access to market information, farmers are making <strong>more informed decisions than ever before</strong>.</p>
        
        <h3 class="text-xl font-semibold text-[#004534] mb-3 mt-6">Key Changes in Farmer Behavior</h3>
        <ul class="list-disc pl-6 mb-6 space-y-3 text-[#555]">
          <li><strong>Digital Adoption:</strong> Over 70% of farmers now use smartphones for market prices and weather updates</li>
          <li><strong>Direct Marketing:</strong> Farmers are bypassing intermediaries through FPOs and direct buyer connections</li>
          <li><strong>Quality Focus:</strong> Increased awareness about grading, sorting, and quality parameters</li>
          <li><strong>Financial Literacy:</strong> Better understanding of loans, insurance, and investment options</li>
        </ul>
        
        <h3 class="text-xl font-semibold text-[#004534] mb-3 mt-6">Impact on Agri-Businesses</h3>
        <p class="text-[#555] leading-relaxed mb-4">These changes are forcing agri-businesses to adapt:</p>
        <ol class="list-decimal pl-6 mb-6 space-y-2 text-[#555]">
          <li><strong>Transparency:</strong> Businesses must offer fair, transparent pricing</li>
          <li><strong>Value Addition:</strong> Simply aggregating produce is no longer enough</li>
          <li><strong>Technology Integration:</strong> Digital platforms are becoming essential for business operations</li>
          <li><strong>Relationship Building:</strong> Long-term partnerships replace transactional relationships</li>
        </ol>
        
        <div class="bg-[#004534] text-white p-6 my-8 rounded-lg">
          <h4 class="font-semibold text-[#D3FF62] mb-2">The Rise of Farmer Producer Organizations (FPOs)</h4>
          <p class="text-white/90">FPOs are enabling farmers to negotiate better prices, access inputs at lower costs, and participate in value chains. The government's target of <strong>10,000 new FPOs</strong> is transforming rural commerce.</p>
        </div>
        
        <h3 class="text-xl font-semibold text-[#004534] mb-3 mt-6">MLDC Agro's Approach</h3>
        <p class="text-[#555] leading-relaxed mb-4">At MLDC Agro, we embrace these changes by:</p>
        <ul class="list-disc pl-6 mb-6 space-y-2 text-[#555]">
          <li>Offering transparent pricing based on quality parameters</li>
          <li>Providing market intelligence to farmer partners</li>
          <li>Building long-term relationships based on trust</li>
          <li>Supporting FPOs with market linkages and technical assistance</li>
        </ul>
        
        <p class="text-[#0C6951] font-medium italic mt-8">The future belongs to those who empower farmers. Join us in building a stronger agricultural ecosystem.</p>
      </div>
    `
  },
  {
    id: 4,
    title: "Bio CNG Project - Sustainable Energy from Agriculture",
    date: "15 December 2025",
    excerpt: "How agricultural waste can be converted into clean energy through Bio CNG technology.",
    slug: "bio-cng-project-sustainable-energy",
    image: "/images/photo-1673208769691-e74104d853fd.jpg",
    content: `
      <div class="blog-content">
        <h2 class="text-2xl font-bold text-[#004534] mb-4 mt-8">Bio CNG: Turning Agricultural Waste into Green Gold</h2>
        <p class="text-[#555] leading-relaxed mb-6">Bio CNG (Compressed Natural Gas) represents one of the most promising solutions for sustainable energy in rural India. By converting agricultural residue into clean fuel, we can address multiple challenges - <strong>stubble burning, energy security, and farmer income</strong>.</p>
        
        <h3 class="text-xl font-semibold text-[#004534] mb-3 mt-6">What is Bio CNG?</h3>
        <p class="text-[#555] leading-relaxed mb-6">Bio CNG is produced through <strong>anaerobic digestion</strong> of organic matter such as crop residue, cattle dung, and food waste. The biogas produced is purified and compressed to create a fuel equivalent to natural gas.</p>
        
        <h3 class="text-xl font-semibold text-[#004534] mb-3 mt-6">Benefits of Bio CNG</h3>
        <ul class="list-disc pl-6 mb-6 space-y-3 text-[#555]">
          <li><strong>Environmental:</strong> Reduces stubble burning and associated air pollution</li>
          <li><strong>Economic:</strong> Creates additional income stream for farmers through residue sale</li>
          <li><strong>Energy Security:</strong> Reduces dependence on imported fossil fuels</li>
          <li><strong>Rural Employment:</strong> Creates jobs in collection, processing, and distribution</li>
          <li><strong>Soil Health:</strong> Digestate from bio CNG plants serves as excellent organic fertilizer</li>
        </ul>
        
        <div class="bg-[#FAFFEE] border-l-4 border-[#D3FF62] p-6 my-8 rounded-r-lg">
          <h4 class="font-semibold text-[#004534] mb-2">The SATAT Initiative</h4>
          <p class="text-[#555]">The Government of India's <strong>SATAT (Sustainable Alternative Towards Affordable Transportation)</strong> scheme aims to establish 5,000 bio CNG plants across the country. This represents an investment of over <strong>₹1.75 lakh crore</strong>.</p>
        </div>
        
        <h3 class="text-xl font-semibold text-[#004534] mb-3 mt-6">Opportunities for Farmers</h3>
        <p class="text-[#555] leading-relaxed mb-4">Farmers can benefit from bio CNG in multiple ways:</p>
        <ol class="list-decimal pl-6 mb-6 space-y-2 text-[#555]">
          <li>Selling crop residue to bio CNG plants at <strong>₹1,500-2,500 per tonne</strong></li>
          <li>Using digestate as free organic fertilizer</li>
          <li>Participating as stakeholders in community bio CNG projects</li>
          <li>Reducing fuel costs for farm equipment using bio CNG</li>
        </ol>
        
        <p class="text-[#0C6951] font-medium italic mt-8">Bio CNG is not just fuel - it's a pathway to sustainable agriculture and rural prosperity.</p>
      </div>
    `
  },
  {
    id: 5,
    title: "Potato Stocking: Key Factors to Analyse Till Harvest",
    date: "5 November 2025",
    excerpt: "Critical factors for successful potato storage and market timing.",
    slug: "potato-stocking-key-factors",
    image: "/images/photo-1764587492501-bf8b61c09792.jpg",
    content: `
      <div class="blog-content">
        <h2 class="text-2xl font-bold text-[#004534] mb-4 mt-8">Mastering Potato Storage: A Complete Guide</h2>
        <p class="text-[#555] leading-relaxed mb-6">Successful potato stocking requires careful analysis of multiple factors. From pre-harvest decisions to market timing, <strong>every step impacts your final returns</strong>.</p>
        
        <h3 class="text-xl font-semibold text-[#004534] mb-3 mt-6">Pre-Harvest Considerations</h3>
        <ul class="list-disc pl-6 mb-6 space-y-3 text-[#555]">
          <li><strong>Variety Selection:</strong> Choose varieties with good storage characteristics (Kufri Pukhraj, Kufri Chipsona)</li>
          <li><strong>Harvest Timing:</strong> Ensure proper skin set before harvesting</li>
          <li><strong>Curing Period:</strong> Allow 10-14 days of curing for wound healing</li>
          <li><strong>Moisture Content:</strong> Optimal moisture level of 78-82% for storage</li>
        </ul>
        
        <h3 class="text-xl font-semibold text-[#004534] mb-3 mt-6">Storage Facility Selection</h3>
        <p class="text-[#555] leading-relaxed mb-4">Key factors when choosing cold storage:</p>
        <ol class="list-decimal pl-6 mb-6 space-y-2 text-[#555]">
          <li>Temperature control capability (<strong>2-4°C</strong> for long-term storage)</li>
          <li>Humidity management (<strong>90-95%</strong> relative humidity)</li>
          <li>Ventilation and air circulation systems</li>
          <li>Track record and management practices</li>
          <li>Location and transportation accessibility</li>
        </ol>
        
        <div class="bg-[#004534] text-white p-6 my-8 rounded-lg">
          <h4 class="font-semibold text-[#D3FF62] mb-2">Monitoring During Storage</h4>
          <p class="text-white/90 mb-3">Regular monitoring is essential:</p>
          <ul class="list-disc pl-6 space-y-2 text-white/90">
            <li>Weekly inspection for sprout development and rot</li>
            <li>Temperature and humidity checks</li>
            <li>Removal of damaged tubers</li>
            <li>Assessment of weight loss (normal: 5-8% over 6 months)</li>
          </ul>
        </div>
        
        <h3 class="text-xl font-semibold text-[#004534] mb-3 mt-6">Market Timing Factors</h3>
        <p class="text-[#555] leading-relaxed mb-4">When deciding to sell, consider:</p>
        <ul class="list-disc pl-6 mb-6 space-y-2 text-[#555]">
          <li>Current market prices vs. storage costs</li>
          <li>Upcoming festival demand</li>
          <li>New crop arrival estimates</li>
          <li>Import/export policy changes</li>
          <li>Quality deterioration rate</li>
        </ul>
        
        <p class="text-[#0C6951] font-medium italic mt-8">MLDC Agro provides comprehensive storage solutions and market advisory to help you maximize your potato returns.</p>
      </div>
    `
  },
  {
    id: 6,
    title: "Maximising Potato Yield",
    date: "30 October 2025",
    excerpt: "Best practices and techniques for higher potato production.",
    slug: "maximising-potato-yield",
    image: "/images/photo-1767982619694-32f8450ea5f7.jpg",
    content: `
      <div class="blog-content">
        <h2 class="text-2xl font-bold text-[#004534] mb-4 mt-8">Achieving Higher Potato Yields: Science and Practice</h2>
        <p class="text-[#555] leading-relaxed mb-6">India is the <strong>second-largest potato producer</strong> globally, yet our average yields lag behind global leaders. With proper practices, farmers can increase yields by <strong>30-50%</strong> while maintaining quality.</p>
        
        <h3 class="text-xl font-semibold text-[#004534] mb-3 mt-6">Seed Selection and Treatment</h3>
        <ul class="list-disc pl-6 mb-6 space-y-3 text-[#555]">
          <li><strong>Certified Seeds:</strong> Use certified, disease-free seed potatoes</li>
          <li><strong>Optimal Size:</strong> 30-40g seed pieces with 2-3 eyes</li>
          <li><strong>Seed Treatment:</strong> Treat with fungicides to prevent soil-borne diseases</li>
          <li><strong>Pre-sprouting:</strong> Chitting seeds for uniform emergence</li>
        </ul>
        
        <h3 class="text-xl font-semibold text-[#004534] mb-3 mt-6">Soil Preparation and Nutrition</h3>
        <p class="text-[#555] leading-relaxed mb-4">Potatoes are heavy feeders requiring:</p>
        <div class="bg-[#FAFFEE] p-6 my-6 rounded-lg">
          <table class="w-full text-[#555]">
            <tbody>
              <tr class="border-b border-[#D3FF62]/30">
                <td class="py-2 font-semibold">Nitrogen</td>
                <td class="py-2">150-200 kg/ha in split applications</td>
              </tr>
              <tr class="border-b border-[#D3FF62]/30">
                <td class="py-2 font-semibold">Phosphorus</td>
                <td class="py-2">80-100 kg/ha as basal dose</td>
              </tr>
              <tr class="border-b border-[#D3FF62]/30">
                <td class="py-2 font-semibold">Potassium</td>
                <td class="py-2">100-150 kg/ha for tuber quality</td>
              </tr>
              <tr>
                <td class="py-2 font-semibold">Organic Matter</td>
                <td class="py-2">10-15 tonnes/ha of well-decomposed FYM</td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <h3 class="text-xl font-semibold text-[#004534] mb-3 mt-6">Water Management</h3>
        <p class="text-[#555] leading-relaxed mb-4"><strong>Critical irrigation stages:</strong></p>
        <ol class="list-decimal pl-6 mb-6 space-y-2 text-[#555]">
          <li><strong>Planting to emergence:</strong> Light, frequent irrigation</li>
          <li><strong>Vegetative growth:</strong> Moderate irrigation</li>
          <li><strong>Tuber initiation:</strong> Critical stage - maintain optimal moisture</li>
          <li><strong>Tuber bulking:</strong> Highest water requirement</li>
          <li><strong>Maturation:</strong> Reduce irrigation for skin set</li>
        </ol>
        
        <div class="bg-[#004534] text-white p-6 my-8 rounded-lg">
          <h4 class="font-semibold text-[#D3FF62] mb-3">Pest and Disease Management</h4>
          <ul class="list-disc pl-6 space-y-2 text-white/90">
            <li><strong>Late Blight:</strong> Preventive fungicide sprays, resistant varieties</li>
            <li><strong>Aphids:</strong> Vector control for virus prevention</li>
            <li><strong>Tuber Moth:</strong> Deep planting, proper earthing up</li>
            <li><strong>Bacterial Wilt:</strong> Crop rotation, clean seed</li>
          </ul>
        </div>
        
        <p class="text-[#0C6951] font-medium italic mt-8">Partner with MLDC Agro for quality inputs and technical guidance to maximize your potato farming success.</p>
      </div>
    `
  },
  {
    id: 7,
    title: "Wheat in Contango: Timing the Market for Maximum Gains in India",
    date: "26 October 2025",
    excerpt: "Strategic insights on wheat market timing for better returns.",
    slug: "wheat-in-contango-timing-the-market",
    image: "/images/photo-1592515163942-8e70c7cc1c61.jpg",
    content: `
      <div class="blog-content">
        <h2 class="text-2xl font-bold text-[#004534] mb-4 mt-8">Understanding Wheat Market Dynamics in India</h2>
        <p class="text-[#555] leading-relaxed mb-6">Wheat is India's <strong>second most important food grain</strong>, and understanding market dynamics can significantly impact farmer profitability. The concept of contango in wheat markets offers strategic opportunities for informed sellers.</p>
        
        <h3 class="text-xl font-semibold text-[#004534] mb-3 mt-6">Wheat Market Fundamentals</h3>
        <ul class="list-disc pl-6 mb-6 space-y-3 text-[#555]">
          <li><strong>Harvest Season:</strong> March-April in most of India</li>
          <li><strong>MSP Support:</strong> Government procurement provides price floor</li>
          <li><strong>Storage Options:</strong> Warehouses, private storage, on-farm storage</li>
          <li><strong>Price Seasonality:</strong> Typically lowest at harvest, rises through the year</li>
        </ul>
        
        <h3 class="text-xl font-semibold text-[#004534] mb-3 mt-6">What Creates Contango in Wheat?</h3>
        <p class="text-[#555] leading-relaxed mb-4">Several factors contribute to wheat contango:</p>
        <ol class="list-decimal pl-6 mb-6 space-y-2 text-[#555]">
          <li>Storage and carrying costs</li>
          <li>Interest rates on inventory financing</li>
          <li>Insurance and wastage provisions</li>
          <li>Seasonal demand patterns</li>
          <li>Government stock releases and procurement</li>
        </ol>
        
        <div class="bg-[#FAFFEE] border-l-4 border-[#D3FF62] p-6 my-8 rounded-r-lg">
          <h4 class="font-semibold text-[#004534] mb-3">Strategic Selling Decisions</h4>
          <p class="text-[#555] mb-3">Factors to consider when timing wheat sales:</p>
          <ul class="list-disc pl-6 space-y-2 text-[#555]">
            <li><strong>MSP vs. Market Price:</strong> Compare government procurement rates with open market prices</li>
            <li><strong>Storage Costs:</strong> Calculate carrying costs vs. expected price appreciation</li>
            <li><strong>Quality Degradation:</strong> Factor in potential quality loss over time</li>
            <li><strong>Cash Flow Needs:</strong> Balance immediate needs with profit optimization</li>
            <li><strong>Market Information:</strong> Track government policy changes and import/export decisions</li>
          </ul>
        </div>
        
        <h3 class="text-xl font-semibold text-[#004534] mb-3 mt-6">MLDC Agro's Wheat Services</h3>
        <p class="text-[#555] leading-relaxed mb-4">We support wheat farmers through:</p>
        <ul class="list-disc pl-6 mb-6 space-y-2 text-[#555]">
          <li>Fair procurement at competitive prices</li>
          <li>Quality-based pricing with transparency</li>
          <li>Market intelligence and advisory</li>
          <li>Storage and logistics support</li>
        </ul>
        
        <p class="text-[#0C6951] font-medium italic mt-8">Make informed decisions about your wheat sales with MLDC Agro's market expertise.</p>
      </div>
    `
  }
];

export const images = {
  hero: "/images/drgv99kk_8c106e9b18eaaa45ba447c8cb107621f.jpg",
  farming: "/images/pexels-photo-7415327.jpeg",
  produce: "/images/photo-1714052389982-6d4da4a4a38b.jpg",
  grainProcessing: "/images/pexels-photo-18888035.jpeg",
  wheat: "/images/photo-1564949432792-fda3baf7a756.jpg",
  wheatField: "/images/pexels-photo-20445181.jpeg",
  ricePaddy: "/images/photo-1628081653896-61e610394639.jpg",
  farmerInField: "/images/pexels-photo-35281194.jpeg"
};

export const clientLogos = [
  { name: "Client 1", logo: "" },
  { name: "Client 2", logo: "" },
  { name: "Client 3", logo: "" },
  { name: "Client 4", logo: "" },
  { name: "Client 5", logo: "" }
];

export const navLinks = [
  { name: "Home", path: "/" },
  { name: "About Us", path: "/about" },
  { name: "Services", path: "/services" },
  { name: "Blogs", path: "/blogs" },
  { name: "Careers", path: "/careers" },
  { name: "Contact", path: "/contact" }
];
